module.exports = __webpack_public_path__ + "static/img/Park.c0ad36a.png";